export const postSalePermissions = [
  'administrator',
  'agent',
  'post_sale_view',
  'post_sale_manage',
  'post_sale_assign',
  'post_sale_status_change',
];

export const salesPermissions = [
  'administrator',
  'agent',
  'transactions_view',
  'transactions_manage',
  'post_sale_view',
  'post_sale_manage',
];

export const financePermissions = [
  'administrator',
  'agent',
  'financeiro_view',
  'financeiro_manage',
  'report_manage',
];

export const financeManagePermissions = ['administrator', 'financeiro_manage'];

export const commissionPlanPermissions = [
  'administrator',
  'agent',
  'apoio_manage',
  'financeiro_view',
  'report_manage',
];

export const brokerDashboardPermissions = [
  'administrator',
  'agent',
  'financeiro_view',
  'financeiro_manage',
  'report_manage',
];

export const nucleoPermissions = [
  'administrator',
  'agent',
  'post_sale_view',
  'post_sale_manage',
  'post_sale_assign',
  'post_sale_status_change',
  'partners_manage',
];
